import { useCategoryTreeItem } from '../categoryTree';
import { tvpil } from '../compat/tvpil';
import { useInfiniteQueryWithLimit } from '../hooks/useInfiniteQueryWithLimit';
import { queryKeys } from '../queryKeys';

import { fetchRecommendations } from './fetchRecommendations';

type useRecommendationsArgs = {
  referenceId: string;
  pageSize: number;
  useLimit?: boolean;
};

export function useRecommendations({ referenceId, pageSize, useLimit }: useRecommendationsArgs) {
  const category = useCategoryTreeItem(referenceId);

  return useInfiniteQueryWithLimit({
    queryKey: queryKeys.recommendations(referenceId, pageSize),
    queryFn: ({ pageParam }) =>
      fetchRecommendations({
        pageIndex: pageParam,
        pageSize,
        partnerListTypeIn: String(category!.partnerListTypeIn || tvpil.dms.savedInterestItemsList),
        groupBy: category!.groupBy,
        kSql: category!.aggregatedKSQL,
      }),
    pageSize,
    enabled: Boolean(category),
    limit: useLimit ? category?.railProperty.railItemsLimit : undefined,
  });
}
